import { ICountry } from '@entities/country';
import { createSlice } from '@reduxjs/toolkit';
import { actions } from './country.actions';

export interface StateType {
  countries: ICountry[];
}

const initialState: StateType = {
  countries: [],
};

const countrySlice = createSlice({
  name: 'countrySlice',
  initialState,
  reducers: actions,
});

export const countryReducer = countrySlice.reducer;
export const { setCountries } = countrySlice.actions;
